import { create } from "zustand";

interface SchemesFilterState {
  page: number;
  pageForDownloads: number;
  openModel: boolean;
  openModelForDownloads: boolean;
  startDate: string;
  startDateForDownloads: string;
  endDate: string;
  endDateForDownloads: string;
  schemeKeyword: string;
  stateId: number | null;
  categoryId: number | null;
  selectedGender: string;
  occupationId: number | null;
  educationId: number | null;
  incomeId: number | null;
  sortInAcceding: boolean;
  cityId: number | null;
  searchValue: string;
  status: number | null;
  districtId: number | null;
  currentTab: number;
  applyFilter: boolean;

  // Actions
  setPage: (val: number) => void;
  setPageForDownloads: (val: number) => void;
  setOpenModel: (val: boolean) => void;
  setOpenModelForDownloads: (val: boolean) => void;
  setStartDate: (val: string) => void;
  setStartDateForDownloads: (val: string) => void;
  setEndDate: (val: string) => void;
  setEndDateForDownloads: (val: string) => void;
  setSchemeKeyword: (val: string) => void;
  setStateId: (val: number | null) => void;
  setCategoryId: (val: number | null) => void;
  setSelectedGender: (val: string) => void;
  setOccupationId: (val: number | null) => void;
  setEducationId: (val: number | null) => void;
  setIncomeId: (val: number | null) => void;
  setSortInAcceding: (val: boolean) => void;
  setCityId: (val: number | null) => void;
  setSearchValue: (val: string) => void;
  setStatus: (val: number | null) => void;
  setDistrictId: (val: number | null) => void;
  setCurrentTab: (val: number) => void;
  setApplyFilter: (val: boolean) => void;
  resetFilters: () => void;

  // Derived
  activeFilterCount: () => number;
}

export const useSurveyorResponsesFilterStore = create<SchemesFilterState>((set, get) => ({
  page: 0,
  pageForDownloads: 0,
  openModel: false,
  openModelForDownloads: false,
  startDate: "",
  startDateForDownloads: "",
  endDate: "",
  endDateForDownloads: "",
  schemeKeyword: "",
  stateId: null,
  categoryId: null,
  selectedGender: "",
  occupationId: null,
  educationId: null,
  incomeId: null,
  sortInAcceding: true,
  cityId: null,
  searchValue: "",
  status: null,
  districtId: null,
  currentTab: 0,
  applyFilter: true,

  setPage: (val) => set({ page: val }),
  setPageForDownloads: (val) => set({ pageForDownloads: val }),
  setOpenModel: (val) => set({ openModel: val }),
  setOpenModelForDownloads: (val) => set({ openModelForDownloads: val }),
  setStartDate: (val) => set({ startDate: val }),
  setStartDateForDownloads: (val) => set({ startDateForDownloads: val }),
  setEndDate: (val) => set({ endDate: val }),
  setEndDateForDownloads: (val) => set({ endDateForDownloads: val }),
  setSchemeKeyword: (val) => set({ schemeKeyword: val }),
  setStateId: (val) => set({ stateId: val }),
  setCategoryId: (val) => set({ categoryId: val }),
  setSelectedGender: (val) => set({ selectedGender: val }),
  setOccupationId: (val) => set({ occupationId: val }),
  setEducationId: (val) => set({ educationId: val }),
  setIncomeId: (val) => set({ incomeId: val }),
  setSortInAcceding: (val) => set({ sortInAcceding: val }),
  setCityId: (val) => set({ cityId: val }),
  setSearchValue: (val) => set({ searchValue: val }),
  setStatus: (val) => set({ status: val }),
  setDistrictId: (val) => set({ districtId: val }),
  setCurrentTab: (val) => set({ currentTab: val }),
  setApplyFilter: (val) => set({ applyFilter: val }),

  resetFilters: () =>
    set({
      page: 0,
      pageForDownloads: 0,
      openModel: false,
      openModelForDownloads: false,
      startDate: "",
      startDateForDownloads: "",
      endDate: "",
      endDateForDownloads: "",
      schemeKeyword: "",
      stateId: null,
      categoryId: null,
      selectedGender: "",
      occupationId: null,
      educationId: null,
      incomeId: null,
      sortInAcceding: true,
      cityId: null,
      searchValue: "",
      status: null,
      districtId: null,
      currentTab: 0,
    }),

  activeFilterCount: () => {
    const {
      startDate,
      endDate,
      schemeKeyword,
      stateId,
      categoryId,
      selectedGender,
      occupationId,
      educationId,
      incomeId,
      cityId,
      searchValue,
      status,
      districtId,
    } = get();

    let count = 0;
    if (startDate) count++;
    if (endDate) count++;
    if (schemeKeyword) count++;
    if (stateId) count++;
    if (categoryId) count++;
    if (selectedGender) count++;
    if (occupationId) count++;
    if (educationId) count++;
    if (incomeId) count++;
    if (cityId) count++;
    if (searchValue) count++;
    if (status) count++;
    if (districtId) count++;

    return count;
  },
}));

// 🔹 Custom hook for convenience
export const useActiveFilterCount = () => {
  return useSurveyorResponsesFilterStore((state) => state.activeFilterCount());
};
